import { useState } from 'react'
import Datepicker from 'tailwind-datepicker-react'
export default function DatePickerSingle({ onChange, defaultValue, id }) {
  const [value, setValue] = useState(defaultValue ?? new Date())
  const [show, setShow] = useState()
  const handleChange = (selectedDate) => {
    setValue(selectedDate)
    if (onChange) {
      onChange(selectedDate)
    }
  }
  const handleClose = (state) => {
    setShow(state)
  }

  return (
    <div
      dir="ltr"
      className="w-full"
    >
      <Datepicker
        classNames="relative"
        options={{
          autoHide: true,
          todayBtn: false,
          clearBtn: false,
          maxDate: new Date('2300-01-01'),
          minDate: new Date('1950-01-01'),
          theme: {
            header:
              '!bg-accent-200 p-2 rounded-t-lg flex justify-between items-center',
            background:
              '!bg-white rounded-none border-2 border-muted-500 shadow ',
            input:
              '!bg-white !rounded-none !border-2 !border-l-0 !border-muted-500 outline-none !text-primary-600 !py-[9px] text-right pr-3',
            inputIcon: '!text-primary-600',
            text: '!text-primary-600 !rounded-none  text-white hover:!text-accent-600 !border-2 !border-transparent hover:!border-accent-600 hover:!bg-muted-100',
            disabledText:
              '!text-primary-300 hover:!text-accent-600 !border-2 !border-transparent hover:!border-accent-600 hover:!bg-muted-100 !rounded-none',
            selected: 'bg-accent-600 !rounded-none !text-white',
            day: '!rounded-none !hover:rounded-none',
            weekDay: '',

            icons:
              ' !rounded-none !border-2 !outline-none focus:!ring-0   hover:!text-blue-500 !bg-white !text-primary-600 !py-2 !px-3 hover:!text-accent-600 hover:!border-accent-600',
          },

          datepickerClassNames: 'top-10 ',
          defaultDate: value,
          language: 'ar-ma',
          inputNameProp: 'date',
          inputIdProp: id,

          inputPlaceholderProp: 'Select Date',
          inputDateFormatProp: {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          },
        }}
        onChange={handleChange}
        show={show}
        setShow={handleClose}
      />
    </div>
  )
}
